export default {"src":"/_next/static/media/used-car.ea6345d3.svg","height":31,"width":53,"blurWidth":0,"blurHeight":0};